import { api } from './api';

export interface ConquestTeam {
    team_id: number;
    team_name: string | null;
    short_name: string | null;
    primary_color: string | null;
    map_color?: string | null;
    logo_url: string | null;
    espn_team_id: number | null;
}

export interface RecentConquest {
    league_id: string;
    league_name: string;
    game_id: number | null;
    county_count: number;
    conquest_date: string | null;
    winner: ConquestTeam;
    loser: ConquestTeam | null;
}

export const recentConquestsService = {
    async list(limit = 20, leagueId?: string): Promise<RecentConquest[]> {
        const params = new URLSearchParams({ limit: String(limit) });
        if (leagueId) params.set('league', leagueId);
        const res = await api.get<{ success: boolean; conquests: RecentConquest[] }>(
            `/territories/recent?${params.toString()}`
        );
        if (!res.success || !res.data) throw new Error(res.error || 'Failed to load recent conquests');
        return res.data.conquests || [];
    },
};
